import React, { FunctionComponent } from 'react';

import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Button from '../../Section/TSASimulation/Button';
import Card from '../../Section/TSASimulation/Card';
import Title from '../../Section/TSASimulation/Title';

export const TsaSimulationFragment = graphql`
  fragment TsaSimulationFragment on SanityTsaSimulation {
    link
  }
`;

const useStyles = () => {
  const { colors } = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: colors.primary,
      width: '100%',
    },
    container: {
      boxSizing: 'border-box',
      flexDirection: 'column',
      alignItems: 'center',
    },
  } as const;
};

export type TSASimulationProps = {
  href?: string;
};

const TSASimulation: FunctionComponent<TSASimulationProps> = (props) => {
  const classes = useStyles();
  const { href } = props;

  return (
    <PaletteProvider variant="primary">
      <div css={classes.root}>
        <BreakpointContainer
          css={classes.container}
          padding={{ xs: [8, 4], md: [8, 4] }}
          width="100%"
          maxWidth="md"
        >
          <Title />

          <Card />

          <Button href={href} />
        </BreakpointContainer>
      </div>
    </PaletteProvider>
  );
};

export default TSASimulation;
